'use client';
import React, { useEffect, useLayoutEffect } from 'react';

import loadBackgroudImages from '../../common/loadBackgroudImages';
import ShinyText from '../bg/ShinyText';
function Header() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <header
      className=" page-header bg-img section-padding valign"
      data-background="/assets/imgs/background/bg4.jpg"
      data-overlay-dark="1"
    >
      <div className="container pt-80">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <h3 className="text-u ls1 fz-80">
                {/* <ShinyText 
  text="Terms & Conditions" 
  disabled={false} 
  speed={3} 
  className='custom-class' 
/> */}
                Terms & <span className="fw-200 main-color">Conditions</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
